// extracted by mini-css-extract-plugin
export default {"container":"BubbleNewMessage_container__ZMR7D","bubble":"BubbleNewMessage_bubble__M95cd","avatar":"BubbleNewMessage_avatar__U9DNu"};